import api_comm from "./lib";

async function settings() {
	return api_comm("get", "/site/api/v2/settings");
}

export default settings;
